import { css, styled } from 'styled-components';

export const Container = styled.div<{ isApp: boolean }>`
  padding: 1rem 0;
  background: 'transparent';
  flex: 1;
  max-width: 100%;
  min-width: 18rem;

  @media (min-width: 991px) {
    padding: 0;
    background: transparent;
    margin-top: 1rem;
  }

  .wrapper {
    display: flex;
    gap: 1rem;

    ${({ isApp }) =>
      !isApp &&
      css`
        padding: 0;
      `}

    @media (min-width: 991px) {
      gap: 0.5rem;
      padding: 0;
    }

    > div {
      flex: 1;

      label {
        border: none;
        margin: 0;
        box-shadow: none;
      }

      .custom-input > div > div,
      input {
        margin: 0;
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.dark.contrast};
        border-radius: 10px;
        font-size: 1rem;

        @media (min-width: 991px) {
          background: ${({ theme }) => theme.colors.white};
          border: none;
        }

        svg {
          color: ${({ theme }) => theme.colors.dark.contrast};
        }
      }
      input {
        @media (min-width: 991px) {
          background: ${({ theme }) => theme.colors.white};
          border-color: ${({ theme }) => theme.colors.light.contrast};
          box-shadow: 0px 2px 0px 0px rgba(103, 120, 115, 0.2);
        }
      }
    }

    .button-blue03-bordered {
      border: none;
      background: #d7edeb;
    }
  }
`;
